export const USER_COLLECTION = "users";
export const DRIVING_COURSE_COLLECTION = "drivingCourse";
export const DRIVING_LESSON_COLLECTION = "drivingLessons";
export const COURSE_SESSIONS_COLLECTION = "courseSessions";
